import { render, staticRenderFns } from "./ProfessionalQualification.vue?vue&type=template&id=65c24b92&"
import script from "./ProfessionalQualification.vue?vue&type=script&lang=ts&"
export * from "./ProfessionalQualification.vue?vue&type=script&lang=ts&"
import style0 from "./ProfessionalQualification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports